<template>
  <ProjectFeature class="workplace-feature" stack-breakpoint="767px" left-background-color="#000000" right-background-color="#000000" right-background-image="/assets/tad/tad-demo.webp" left-border-right="6px solid white" left-width="33.3333%" right-width="66.6667%">
    <template #left-header>
      <div class="workplace-feature__header">
        <div class="workplace-feature__brand">
          <img :src="`${useCdnUrl()}/assets/logos/zen-2023-header.svg`" alt="Zenapptic" />
          <span>PRESENTS THE</span>
        </div>

        <h2>
          WORKPLACE
          <br />
          OF THE
          <br />
          FUTURE
        </h2>

        <p class="workplace-feature__intro">
          EXPLORE NEW POSSIBILITIES.
          <br />
          HELP SHAPE WHAT COMES NEXT.
        </p>
      </div>
    </template>

    <template #left-body>
      <div class="workplace-feature__details">
        <div class="workplace-feature__rule" />
        <div class="workplace-feature__detail">
          <span class="workplace-feature__detail-label">OCTOBER 14, 2026</span>
          <span class="workplace-feature__event-time">2:00–7:00 PM</span>
        </div>

        <div class="workplace-feature__rule" />
        <div class="workplace-feature__detail">
          <span class="workplace-feature__detail-label">HOSTED AT</span>
          <div class="workplace-feature__address">
            <img class="workplace-feature__tad" :src="`${useCdnUrl()}/assets/tad/tad-logo-orange.png`" alt="Tad." />
            <span class="workplace-feature__address-copy">
              246 WEST 38TH STREET
              <br />
              NEW YORK, NY 10018
            </span>
          </div>
        </div>
      </div>
    </template>

    <template #left-footer>
      <div class="workplace-feature__actions">
        <NuxtLink class="workplace-feature__link" to="/workplace-of-the-future">WE'D LOVE YOUR INPUT.</NuxtLink>
        <NuxtLink class="workplace-feature__register" to="/workplace-of-the-future">REGISTER NOW</NuxtLink>
      </div>
    </template>

    <template #bottom>
      <div class="workplace-feature__bottom">
        <div class="workplace-feature__bottom-copy">Special thanks to our partners:</div>
        <img :src="`${useCdnUrl()}/assets/tad/NAnolumens.webp`" alt="Nanolumens logo" />
        <img :src="`${useCdnUrl()}/assets/tad/Salamander.webp`" alt="Salamander logo" />
        <img :src="`${useCdnUrl()}/assets/tad/ots-logo-black.webp`" alt="One Times Square logo" />
      </div>
    </template>
  </ProjectFeature>
</template>

<style lang="scss">
.workplace-feature {
  .project-feature__left {
    gap: 7rem;
    padding-bottom: 3rem;
    padding-top: 3rem;

    @media (max-width: 1024px) {
      padding-bottom: 5rem;
    }

    @media (max-width: 767px) {
      border-width: 0;
      flex-basis: 100%;
      gap: 2rem;
      padding: 3rem 2rem;
      width: 100%;
    }
  }

  .project-feature__right {
    min-height: 32rem;

    @media (max-width: 1024px) {
      min-height: 28rem;
      overflow: visible;
    }

    @media (max-width: 767px) {
      min-height: 22rem;
    }
  }

  @media (min-width: 768px) and (max-width: 1024px) {
    .project-feature__left {
      flex-basis: 50%;
    }

    .project-feature__right {
      flex-basis: 50%;
      width: 50%;
    }
  }

  &__header {
    h2 {
      color: white;
      font-size: clamp(4.2rem, 5vw, 7rem);
      font-weight: 700;
      letter-spacing: -0.05em;
      line-height: 0.88;
      margin: 0;
    }
  }

  &__brand {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
    margin-bottom: 2.5rem;

    img {
      display: block;
      max-width: 20rem;
      transform: translateX(-3.75%);
      width: 100%;
    }

    span {
      color: #b8b8b8;
      font-size: 1.8rem;
      font-weight: 100;
      line-height: 1;
    }
  }

  &__intro {
    color: #b8b8b8;
    font-size: inherit;
    font-weight: 100;
    line-height: 1.15;
    margin: 2rem 0 0;
  }

  &__details {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &__rule {
    background-color: #f15a24;
    height: 1px;
    width: 4rem;
  }

  &__detail {
    color: white;
    display: flex;
    flex-direction: column;
    font-size: 1.8rem;
    gap: 0.4rem;
    line-height: 1.15;
  }

  &__detail-label {
    color: #2d9cdb;
    font-size: 2.6rem;
    font-weight: 300;
  }

  &__event-time {
    color: #b8b8b8;
    font-size: 1.5rem;
  }

  &__address {
    align-items: center;
    column-gap: 1rem;
    display: grid;
    font-weight: 100;
    grid-template-columns: auto 1fr;
  }

  &__tad {
    display: block;
    height: 5rem;
    object-fit: contain;
    width: 5rem;
  }

  &__address-copy {
    color: #b8b8b8;
    font-size: 1.5rem;
    line-height: 1.15;
  }

  &__link {
    color: white;
    font-size: inherit;
    font-weight: 700;
    text-decoration: none;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &__register {
    align-self: flex-start;
    background-color: #2d9cdb;
    color: white;
    font-size: 1.8rem;
    font-weight: 700;
    padding: 1rem 2rem;
    text-decoration: none;

    &:hover {
      background-color: white;
      color: black;
    }

    @media (max-width: 767px) {
      align-self: stretch;
      text-align: center;
    }
  }

  &__bottom {
    align-items: center;
    background-color: white;
    color: black;
    display: grid;
    gap: 7rem;
    grid-template-columns: repeat(4, max-content);
    justify-content: center;
    padding: 2.5rem 5rem;
    text-align: center;
    width: 100%;

    @media (min-width: 768px) and (max-width: 1024px) {
      gap: 1.5rem;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      padding: 2rem;
    }

    @media (max-width: 767px) {
      gap: 3rem;
      grid-template-columns: max-content;
      padding: 2rem;
    }
  }

  &__bottom-copy {
    font-size: 1.8rem;
    font-weight: 100;
    line-height: 1.1;
    text-align: center;

    @media (min-width: 768px) and (max-width: 1024px) {
      font-size: 1.5rem;
    }

    @media (max-width: 767px) {
      grid-column: 1 / -1;
    }
  }

  &__bottom > img {
    height: auto;
    justify-self: center;
    max-height: 5rem;
    max-width: 100%;
    object-fit: contain;
    width: auto;

    @media (min-width: 768px) and (max-width: 1024px) {
      max-width: 100%;
    }

    &:nth-of-type(1),
    &:nth-of-type(2) {
      max-height: 3.5rem;
    }

    @media (max-width: 767px) {
      max-height: 3.5rem;

      &:nth-of-type(3) {
        max-height: 5rem;
      }
    }
  }
}
</style>
